export const placeData = {
	title: "Informações de contrato",
	description: "Informações gerais da conta",
	loading: "Carregando...",
	accessDenied: {
		title: "Acesso Negado",
		description: "Você não tem permissão para acessar esta tela.",
	},
	error: {
		title: "Erro",
		description: "Ocorreu um erro ao carregar os dados. Tente novamente.",
	},
	sections: {
		general: {
			title: "Geral",
			description: "Informações gerais da conta",
		},
		fees: {
			title: "Taxas",
			description: "Valores representam a taxa que será aplicada sobre os itens abaixo",
		},
		balanceModel: {
			title: "Modelo de saldo",
			description: "Definição de retorno do saldo",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Tipo de entrega configurado",
		},
		eventCurrency: {
			title: "Moeda do evento",
			description: "Moeda e proporção usada",
		},
		smartPosSettings: {
			title: "Configurações de SmartPOS",
			description: "Dados de integração",
		},
		communication: {
			title: "Comunicação",
			description: "Envio de mensagens (SMS e WhatsApp)",
		},
		charges: {
			title: "Cobranças",
			description: "Produtos e equipamentos adquiridos",
		},
	},
	fields: {
		contractNumber: "Número do contrato",
		profile: "Perfil",
		mainVersion: "Versão principal",
		guaranteedMonthlyMinimum: "Mínimo mensal garantido",
		monthlyBillingCap: "Teto mensal de cobrança",
		zigResponsible: "Responsável ZIG",
		placeStatus: "Status do place",
		zigLocation: "Localização Zig",
		rechargeNotIntegratedLimit: "Limite de recarga não integrada",
		nonIntegratedPaymentLimit: "Limite de pagamento não integrado por device e evento",
		localResponsible: "Responsável(is) pelo local",
		minVersion: "Versão mínima do PDV",
		placeClassification: "Classificação do local",
		smsNumbers: "Números para envio de SMS de receita",
		serviceFee: "Taxa de serviço",
		deliveryFee: "Taxa de entrega",
		onlineDeliveryFee: "Taxa de delivery online",
		advanceReservationFee: "Taxa de cobrança antecipada em reservas",
		parentPlaceName: "Place Pai",
		ppuAuthorizationValue: "Valor da pré autorização do app",
		status: {
			active: "Ativo",
			blocked: "Bloqueado",
			inactive: "Inativo",
			paused: "Pausado",
		},
		house: "Casa",
		profileValues: {
			barAndRestaurant: "Bar e Restaurante",
			restaurant: "Restaurante",
			concertHall: "Casa de Shows",
			bar: "Bar",
			nightclub: "Boate",
			park: "Parque",
			sportsArena: "Arena Esportiva",
			other: "Outro",
		},
		processingFee: "Taxa de processamento",
		platformFee: "Taxa da plataforma",
		balanceReturnType: "Tipo de retorno do saldo",
		returnPeriod: "Período de retorno",
		minimumBalance: "Saldo mínimo",
		maximumBalance: "Saldo máximo",
		deliveryType: "Tipo de entrega",
		deliveryTime: "Tempo de entrega",
		deliveryRadius: "Raio de entrega",
		deliveryTypes: {
			counterDelivery: "Entrega no balcão",
			tableDelivery: "Entrega na mesa",
		},
		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Dias até a liquidação do IFood",
				fee: "Taxa iFood",
				description: "Configurações do IFood",
			},
		},
		delveryOnlineRules: "Regras de delivery online",
		currency: "Nome",
		exchangeRate: "Proporção para moeda do país",
		currencySymbol: "Símbolo",
		decimalPlaces: "Casas decimais",
		integrationStatus: "Status da integração",
		apiVersion: "Versão da API",
		lastSync: "Última sincronização",
		syncFrequency: "Frequência de sincronização",
		smsCost: "Custo do  envio",
		whatsappCost: "Custo do envio",
		whatsappNumber: "Numéro",
		whatsappId: "ID do serviço",
		pushNotifications: "Notificações push",
		placeType: "Tipo do Place",
		placeTypesValues: {
			default: "Padrão",
			delivery: "Delivery",
			transfers: "Repasses",
			advance: "Advance",
			billing: "Cobranças",
		},
		zigFeeShouldBeChargedInDebit: "Cobrar taxa Zig na data de débito",
		hasCustomizedCard: "Depósito caução é do cliente",
		user: "Usuário",
		fiscalPrinters: "Impressoras fiscais",
		name: "Impressoras",
		bankAccountData: "Dados de conta bancária",
		receivingAccount: "Conta de recebimento",
		accountHolder: "Titular da conta",
		documentType: "Tipo de documento",
		digit: "Dígito",
		accountIdentification: "Identificação da conta",
		accountIdentifier: "Identificador da conta",
		cpfCnpj: "CPF/CNPJ",
		accountType: "Tipo de conta",
		accountTypes: {
			conta_corrente: "Corrente",
			conta_poupanca: "Poupança",
			conta_salario: "Salário",
		},
		registrationData: "Dados para cadastrar",
		bankData: "Dados bancários",
		branch: "Agência",
		bank: "Banco",
		bankName: "Nome do banco",
		account: "Conta",
		recharges: "Recargas",
		rechargeValidityCriteria: "Validade e critérios de recarga",
		rechargesExpireIn: "Recargas expiram em",
		remainingRechargeActions: "Ações da sobra de recarga",
		chargeBack: "Expirar ao fim do evento",
		placeOnly: "Gerenciadas pela casa",
		normal: "Gerenciadas pelo Zig",
		// Taxas e valores
		rateType: "Tipo",
		rateTypeLabel: "Tipo de taxa",
		singleRate: "Taxa única",
		segmentedFeeType: "Taxa segmentada",
		singleFeeType: "Taxa única",
		systemFee: "Taxa de sistema",
		inHouseConsumption: "Consumo na casa",
		ticketOfficeRevenue: "Receita de bilheteria",
		rechargeSurplus: "Sobra de recarga",
		bonus: "Bônus",
		fixedFee: "Taxa fixa",
		appFee: "Taxa sobre app",
		prechargeOnlinePaymentFee: "Taxa de pré-carga/pagamento online",
		fixedFeePaymentDay: "Dia do pagamento da taxa fixa",
		anticipationFee: "Taxa de antecipação",
		thirdPartyPaymentFee: "Taxa de pagamento de terceiros",
		// Pagamento com máquina ZigPay
		zigPayMachinePayment: "Pagamento com máquina ZigPay",
		debit: "Débito",
		credit: "Crédito",
		creditOtherFlags: "Crédito (Outras bandeiras)",
		debitOtherFlags: "Débito (Outras bandeiras)",
		replicateRatesForAllFlags: "Replicar taxas para todas as bandeiras?",
		pix: "Pix",
		pixKey: "Chave Pix",
		pixKeyType: "Tipo de Chave PIX",
		yes: "Sim",
		// Vale alimentação
		foodVoucher: "Vale alimentação",
		// Pagamento com máquina integrada em EC do cliente
		integratedMachinePayment: "Pagamento com máquina integrada em EC do cliente",
		machineCommission: "Comissão das maquininhas",
		anticipatedConsumption: "Consumação antecipada",
		anticipatedBar: "Antecipado/Bar",
		ticketOffice: "Bilheteria",
		// Dias até a cobrança
		daysUntilCollection: "Dias até a cobrança",
		daysUntilCollectionDescription:
			"Quantidade de dias para exercer a cobrança e pagamentos nos seguintes formatos",
		collectionDaysDescription:
			"Quantidade de dias para exercer a cobrança e pagamentos nos seguintes formatos",
		// Parcelamento
		installment: "Parcelamento",
		installmentFee: "Taxa de parcelamento",
		maxInstallments: "Número máx. de parcelas",
		notApplicable: "Não se aplica",
		// Cobranças
		chargeTitle: "Título",
		chargeCategory: "Categoria",
		chargeRecurrence: "Recorrência",
		chargeStartDate: "Começo",
		chargeEndDate: "Término",
		chargeInstallmentValue: "Valor da parcela",
		installmentRate: "Taxa de parcelamento",
		maxInstallmentsNumber: "Número máx. de parcelas",
		// Categorias de ajuste
		adjustmentCategories: {
			anticipationFee: "Taxa de Antecipação",
			balanceAdjustment: "Balanceamento de Saldo",
			bonifications: "Outras Bonificações",
			cardActivations: "Taxa de Ativação",
			equipmentsMaintenance: "Manutenção de Equipamentos",
			equipmentsPurchase: "Compra de Equipamentos",
			equipmentsRental: "Aluguel de Equipamentos",
			expiredRecharges: "Recargas Expiradas",
			generalZigMachineTax: "Taxas de Adquirência sobre Máquinas Integradas",
			generalZigMachineTPV: "Faturamento via adquirência integrada ZIG",
			genericOperationsFee: "Despesas Gerais de Operação",
			genericServices: "Outros Serviços e Cobranças",
			notUsedRecharges: "Sobra de Recargas",
			operatorFee: "Diária de Operador",
			payments: "Pagamentos",
			paymentsTax: "Taxa de Pagamento a Fornecedores",
			pos: "Faturamento em Máquinas Não Integradas (POS)",
			posTax: "Taxa de Adiquirência sobre Máquinas Não Integradas (POS)",
			reimbursements: "Reembolsos a Clientes",
			systemSetup: "Setup de Sistema",
			totemFee: "Taxa de Totem",
			wifiAssistance: "Assistência Técnica de Wifi",
			wifiSetup: "Setup de Wifi",
			withdraw: "Saques",
			zigDevicePurchase: "Compra de Comandas",
			zigFee: "Taxa Zig",
			totenRental: "Aluguel de Totem",
			others: "Outros",
			renegotiation: "Renegociação",
			advance: "Adiantamento",
			advanceFee: "Taxa de Adiantamento",
			balanceRetention: "Retenção de Saldo",
			balanceTransfer: "Transferência Entre Places",
			residueRemain: "Retenção de Resíduo",
			missingCards: "Cartões Extraviados",
			billingInvoice: "Cobrança Nota Fiscal",
			guaranteedMinimumSupplement: "Complemento Mínimo Garantido",
			commandFiscalPurchase: "Compra de Comanda Fiscal",
			accountsReceivableLegal: "CR - Jurídico",
			cardDiscount: "Desconto de Cartões",
			discountGeneralOperatingExpenses: "Desconto Despesas Gerais de Operação",
			discountOperatorDailyRate: "Desconto Diária de Operador",
			generalDiscount: "Desconto Geral",
			dailyCoordinatorRate: "Diárias de Coordenadores",
			dailyHeadsRate: "Diárias de Heads",
			setupDailyCoordinatorRate: "Diárias de Setup Coordenadores",
			setupDailyHeadsRate: "Diárias de Setup Heads",
			setupDailySupervisorsRate: "Diárias de Setup Supervisores",
			setupDailyTechnicalRate: "Diárias de Setup Técnico",
			setupDailyTraineeRate: "Diárias de Setup Trainee",
			dailySupervisorRate: "Diárias de Supervisores",
			dailyTechnicianRate: "Diárias de Técnico",
			dailyTraineeRate: "Diárias de Trainee",
			damagedEquipment: "Equipamento Avariados",
			integratedAPPBilling: "Faturamento App Integrado",
			apartCreditBilling: "Faturamento Crédito Apartado",
			integratedCreditBilling: "Faturamento Crédito Integrado",
			apartDebitBilling: "Faturamento Débito Apartado",
			integratedDebitBilling: "Faturamento Débito Integrado",
			apartBillingPIX: "Faturamento PIX Apartado",
			integratedPIXBilling: "Faturamento PIX Integrado",
			integratedAdvancedRechargeBilling: "Faturamento Recarga Antecipado Integrado",
			interestandPenalties: "Juros e Multa",
			softwareLicense: "Licença de Software",
			replacedMachines: "Máquinas Substituidas",
			minimumGuaranteedpermachine: "Mínimo Garantido por máquina",
			otherEquipment: "Outros Equipamentos",
			rebate: "Rebate",
			setupAdvancedRecharge: "Setup Recarga Antecipada",
			setupRefundSite: "Setup Site de Reembolso",
			acquirementfeeforIntegratedZIGApplication:
				"Taxa de adquirência sobre Aplicativo ZIG Integrado",
			acquiringfeeonapartCredit: "Taxa de adquirência sobre Crédito Apartado",
			acquiringfeeforIntegratedCredit: "Taxa de adquirência sobre Crédito Integrado",
			acquiringfeeforapartDebit: "Taxa de adquirência sobre Débito Apartado",
			acquiringfeeonIntegratedDebit: "Taxa de adquirência sobre Débito Integrado",
			acquiringfeeforapartPIX: "Taxa de adquirência sobre PIX Apartado",
			acquiringfeeforIntegratedPIX: "Taxa de adquirência sobre PIX Integrado",
			acquiringfeeforAdvancedRecharge: "Taxa de adquirência sobre Recarga Antecipada",
			refundfee: "Taxa de Reembolso",
			relatedpartyretentionfee: "Taxa de retenção de partes relacionadas",
			rappiFee: "Taxa Rappi",
			SMSFee: "Taxa SMS",
			residualFee: "Taxa sobre Resíduo",
			cardtoCashExchange: "Troca de Cartões por Dinheiro",
			cardtoProductExchange: "Troca de Cartões por Produto",
			travelFood: "Alimentação de Viagem",
			shipping: "Frete",
			accommodation: "Hospedagem",
			transport: "Transporte",
			pixRefundFee: "Taxa Reembolso PIX",
			softwareLicenseMachine: "Licença de Software Máquina",
			softwareLicenseTotem: "Licença de Software Totem",
			integratedAdvanceDebitBilling: "Faturamento Débito Antecipado Integrado",
			integratedAdvanceCreditBilling: "Faturamento Crédito Antecipado Integrado",
			integratedAdvancePixBilling: "Faturamento Pix Antecipado Integrado",
			integratedAdvanceDebitFee: "Taxa Débito Antecipada Integrado",
			integratedAdvanceCreditFee: "Taxa Crédito Antecipada Integrado",
			integratedAdvancePixFee: "Taxa Pix Antecipada Integrado",
			integratedOnlineDeliveryIncome: "Faturamento Delivery Online Integrado",
			zeDeliveryDiscount: "Desconto Zé Delivery",
			ticketPrinting: "Impressão de ingressos",
			validatorRental: "Licença de Validadores",
			zeDeliveryRetention: "Retenção Zé Delivery",
			valueAddedTax: "IVA",
			moneyTPV: "TPV Dinheiro",
			acquiringFeeForIntegratedInstallmentCredit:
				"Taxa de adquirência sobre Crédito Parcelado Integrado",
			issuedCharge: "Cobrança Emitida",
			softwareLicenseGiftback: "Licença de Software Giftback",
			loanBracelet: "Empréstimo de pulseira",
			lendingCards: "Empréstimo de cartão",
			externalResourceContribution: "Aporte de recursos externos",
			anticipationValue: "Valor de Antecipação",
			anticipatedValue: "Valor Antecipado",
			generalZigMachineCreditIn2Installments: "TPV Credito parcelado 2X",
			generalZigMachineCreditIn3Installments: "TPV Credito parcelado 3X",
			generalZigMachineCreditIn4Installments: "TPV Credito parcelado 4X",
			generalZigMachineCreditIn5Installments: "TPV Credito parcelado 5X",
			generalZigMachineCreditIn6Installments: "TPV Credito parcelado 6X",
			generalZigMachineCreditIn7Installments: "TPV Credito parcelado 7X",
			generalZigMachineCreditIn8Installments: "TPV Credito parcelado 8X",
			generalZigMachineCreditIn9Installments: "TPV Credito parcelado 9X",
			generalZigMachineCreditIn10Installments: "TPV Credito parcelado 10X",
			generalZigMachineCreditIn11Installments: "TPV Credito parcelado 11X",
			generalZigMachineCreditIn12Installments: "TPV Credito parcelado 12X",
			generalZigMachineCreditIn2InstallmentsFEE: "Taxa Credito Parcelado 2X",
			generalZigMachineCreditIn3InstallmentsFEE: "Taxa Credito Parcelado 3X",
			generalZigMachineCreditIn4InstallmentsFEE: "Taxa Credito Parcelado 4X",
			generalZigMachineCreditIn5InstallmentsFEE: "Taxa Credito Parcelado 5X",
			generalZigMachineCreditIn6InstallmentsFEE: "Taxa Credito Parcelado 6X",
			generalZigMachineCreditIn7InstallmentsFEE: "Taxa Credito Parcelado 7X",
			generalZigMachineCreditIn8InstallmentsFEE: "Taxa Credito Parcelado 8X",
			generalZigMachineCreditIn9InstallmentsFEE: "Taxa Credito Parcelado 9X",
			generalZigMachineCreditIn10InstallmentsFEE: "Taxa Credito Parcelado 10X",
			generalZigMachineCreditIn11InstallmentsFEE: "Taxa Credito Parcelado 11X",
			generalZigMachineCreditIn12InstallmentsFEE: "Taxa Credito Parcelado 12X",
			totalTpvBarIncome: "Taxa Recebimento Bar",
			totalTpvEntranceIncome: "Taxa Recebimento Bilheteria",
			totalTpvEntranceIncomeConsumption: "Taxa Recebimento Consumo Bilheteria",
			totalTpvBarMinimumConsumption: "Taxa Minima Recebimento Bar",
			totalTpvBonus: "Taxa Recebimento Bonus",
			advanceRenegotiation: "Renegociação de Advance",
			zigTicketsRetention: "Retenção Zig Tickets",
			onlineDeliveryAcquisitionFee: "Taxa de Adquirência sobre Delivery Online",
			bankRefund: "Reembolso bancário",
			acquirerRefund: "Reembolso adquirência",
			pixPreventiveBlock: "Pix - Bloqueio Preventivo",
			pixAuthorizedUnblock: "Pix - Desbloqueio Autorizado",
			pixRefundByChargeback: "Pix - Estorno por Chargeback",
			RelatedStakeholderRetentionReprocessing: "Retenção e Reprocessamento",
			cleaning: "Limpeza",
			electrical: "Elétrica",
			hydraulics: "Hidráulica",
			supply: "Fornecimento",
		},
		// Recorrências
		adjustmentRecurrences: {
			daily: "Diária",
			event: "Por evento",
			monthly: "Mensal",
			weekly: "Semanal",
		},
	},
};
